import { useMutation, useQueryClient } from 'react-query';
import { toast } from 'sonner';

import { APIBaseChronos } from '../hosts';
import { QueryEntity } from '../types';
import useGetFetchConfig, { FetchMethod } from '../useGetFetchConfig';

interface UpdateSpeakerParams {
  caseId: string;
  transcriptId: string;
  speakerId: string;
  name: string;
}

export const useUpdateSpeaker = () => {
  const { getFetchConfig } = useGetFetchConfig();
  const queryClient = useQueryClient();

  const updateSpeaker = async (data: UpdateSpeakerParams) => {
    const fetchConfig = getFetchConfig({
      method: FetchMethod.PATCH,
      data: { name: data.name },
    });

    await fetch(
      `${APIBaseChronos}/api/case/${data.caseId}/transcripts/${data.transcriptId}/speakers/${data.speakerId}`,
      fetchConfig,
    );
  };

  return useMutation({
    mutationFn: updateSpeaker,
    onSuccess: () => {
      toast.success('Speaker updated successfully');
      queryClient.invalidateQueries([QueryEntity.Transcripts]);
    },
    onError: () => {
      toast.error('Failed to update speaker');
    },
  });
};
